import { ListRange, SearchCriteriaBase } from '../../../../../../common/models';
import { ListQueryParam } from '../../../../../../common/constants/list-query-param.constant';

export class FailedMessagesProfileListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: Partial<FailedMessagesProfileListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
